module.exports = __webpack_public_path__ + "static/media/levaty.fd3fef5d.png";